const runAnimationsInElement = (element, reveal) => {
  element.querySelectorAll('[data-scroll-animation]').forEach(animation => {
    animation.classList.toggle('animate', reveal)
  })
}

const tabs = el => {
  const toggles = Array.from(el.querySelectorAll('[data-tab-toggle]'))
  const tabsElements = Array.from(el.querySelectorAll('[data-tab]'))
  let transitionInProgress = false

  const togglePointerEvents = enable => {
    toggles.forEach(toggle => toggle.classList.toggle('disabled', !enable))
  }

  const updateToggles = activeIndex => {
    toggles.forEach((currentToggle, index) => {
      currentToggle.classList.toggle('active', activeIndex === index)
    })
  }

  const updateTabsDisplay = activeIndex => {
    tabsElements.forEach((tab, tabIndex) => {
      tab.style.display = tabIndex === activeIndex ? '' : 'none'
    })
  }

  toggles.forEach((toggle, index) => {
    toggle.addEventListener('click', () => {
      if (transitionInProgress) return
      transitionInProgress = true

      togglePointerEvents(false)

      // hide animation
      tabsElements
        .filter((tab, i) => i !== index)
        .forEach(tab => runAnimationsInElement(tab, false))

      setTimeout(() => {
        updateToggles(index)
      }, 0)

      setTimeout(() => {
        updateTabsDisplay(index)

        //  reveal animation
        setTimeout(() => {
          runAnimationsInElement(tabsElements[index], true)
          transitionInProgress = false
          togglePointerEvents(true)
        }, 100)
      }, 800)
    })
  })

  updateToggles(0)
  updateTabsDisplay(0)

  // fix bug on mobile when 2nd slide is not shown because of 0.45 threshold
  if (tabsElements[0]) {
    const swiperWrapper = tabsElements[0].querySelector('.swiper-wrapper')
    if (swiperWrapper) {
      runAnimationsInElement(swiperWrapper, true)
    }
  }
}

export default tabs
